var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.documentData)?_c('HorizontalCard',{attrs:{"large":"","show-image":"","show-tags":"","document-data":_vm.documentData,"show-evaluation":false,"allow-adding-to-reflection":true,"is-loading":_vm.isLoading}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }